export default {
  qualificationTitle: 'Votre qualification',
  qualificationTitleMinor: 'La qualification retenue pour votre enfant',

  qceTitle: 'Vos connaissances et votre expérience en matière de produits financiers',
  qceTitleMinor:
    'Le niveau de connaissances et d’expérience en matière de produits financiers',

  qceDescriptionStandard:
    'Selon vos réponses au questionnaire d’évaluation réalisé le {date}, votre niveau de connaissances et d’expérience en matière de placements financiers est {label}.',

  qceMinorTwoRepresentatives: {
    representative1:
      '{firstName} {lastName} : Selon vos réponses au questionnaire d’évaluation réalisé le {date}, votre niveau de connaissance et d’expérience en matière de placement financier est {label}.',
    representative2:
      '{firstName} {lastName} : Selon vos réponses au questionnaire d’évaluation réalisé le {date}, votre niveau de connaissance et d’expérience en matière de placement financier est {label}.',
    conclusion:
      'Le niveau de connaissances et d’expérience retenu pour votre enfant est le moins disant soit {label}.',
  },

  qceMinorMissingRepresentative: {
    representativePresent:
      '{firstName} {lastName} : Selon vos réponses au questionnaire d’évaluation réalisé le {date}, votre niveau de connaissance et d’expérience en matière de placement financier est {label}.',
    conclusion:
      'Compte tenu de l’absence d’un des représentants légaux, le niveau de connaissances et d’expérience retenu pour votre enfant est Débutant quel que soit le niveau du représentant légal présent.',
  },

  qceMinorSingleRepresentative: {
    representative:
      '{firstName} {lastName} : Selon vos réponses au questionnaire d’évaluation réalisé le {date}, votre niveau de connaissance et d’expérience en matière de placement financier est {label}.',
    conclusion:
      'Le niveau de connaissances et d’expérience retenu pour votre enfant est {label}.',
  },

  piTitle: 'Votre profil d’investisseur',
  piTitleMinor: 'Le profil d’investisseur',

  piDescriptionStandard:
    'D’après vos réponses à notre questionnaire réalisé le {date}, vous avez un profil d’investisseur {label}.',
  piDescriptionMinor:
    'Vous avez choisi un profil d’investisseur {label} pour votre enfant.',

  piObjectives: {
    conservative:
      'Vous souhaitez avant tout protéger votre épargne du risque de perte en capital en acceptant un niveau limité de rendement.',
    conservativeMinor:
      'Vous souhaitez avant tout protéger le patrimoine de votre enfant du risque de perte en capital en acceptant un niveau limité de rendement.',
    defensive:
      'Vous cherchez une valorisation du capital tout en acceptant un niveau de risque faible.',
    balanced:
      'Vous cherchez une valorisation du capital par le biais d’un juste équilibre entre sécurité et performance.',
    dynamic:
      'Vous cherchez une valorisation du capital tout en acceptant un niveau de risque élevé.',
    aggressive:
      'Vous acceptez les risques liés aux produits et aux marchés financiers ainsi que les fluctuations très importantes de votre capital tout en espérant une forte valorisation.',
  },

  riskScaleTitle: 'Échelle de risque',
  riskScaleInitial: 'Initial : {value}',
  riskScaleTarget: 'Cible : {value}',

  esgTitle: 'Votre profil de durabilité',
  esgTitleMinor: 'Le profil de durabilité',

  esgDescription:
    'D’après vos réponses à notre questionnaire de durabilité, réalisé le {date}, vous avez un profil de durabilité {label}.',

  esgApproachGeneric:
    'Vous vous appuyez sur les critères retenus par LCL pour la prise en compte des enjeux de durabilité dans vos décisions d’investissement.',

  sfdrNeutral:
    'Vous ne prenez pas en compte la durabilité dans vos décisions d’investissement (Alignement SFDR neutre).',
  sfdrAlignment:
    'Vous prenez en compte la durabilité dans vos décisions d’investissement (Alignement minimum SFDR de {value} %).',

  taxonomyNeutral:
    'Vous ne souhaitez pas investir dans des entreprises qui contribuent positivement à des enjeux de développement durable (Alignement taxonomie neutre).',
  taxonomyAlignment:
    'Vous souhaitez investir dans des entreprises qui contribuent positivement à des enjeux de développement durable (Alignement minimum à taxonomie de {value} %).',

  paiNeutral: {
    intro:
      'Vous ne souhaitez pas tenir compte des impacts négatifs sur les thématiques suivantes (Principales Incidences Négatives) :',
    items: [
      'les émissions de gaz à effet de serre et la consommation énergétique',
      'les atteintes à la biodiversité',
      'les émissions polluantes dans l’eau',
      'la génération de déchets dangereux',
      'le non-respect des droits humains et normes sociales internationales',
      'l’inégalité femmes hommes (rémunération, diversité des genres dans les conseils d’administration)',
    ],
  },
  paiTaken: {
    intro:
      'Vous souhaitez investir dans des activités durables prenant en compte les enjeux environnementaux et/ou sociaux.',
    secondaryIntro:
      'Vous souhaitez tenir compte des impacts négatifs sur les thématiques suivantes (Principales Incidences Négatives) :',
  },
}
